// extracted by mini-css-extract-plugin
module.exports = {"text":"_02712f2b3b--text--rMX1d","data":"_02712f2b3b--data--bZPuq","percent":"_02712f2b3b--percent--BK2Zq","percent-bar":"_02712f2b3b--percent-bar--NQfZK"};